import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AsmAdapter, AsmConnector, OccAsmAdapter } from './lib';
import { AsmStoreModule } from './lib/store/asm-store.module';

@NgModule({
  imports: [CommonModule, AsmStoreModule],
  providers: [
    AsmConnector,
    AsmStoreModule,
    {
      provide: AsmAdapter,
      useClass: OccAsmAdapter,
    },
  ],
})
export class AsmDataAccessModule {}
